import { ImageUploadModule } from 'angular2-image-upload';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SnotifyModule, SnotifyService } from 'ng-snotify';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { LocalsLogComponent } from './locals-log/locals-log.component';
import { LocalsRoutingModule } from './locals-routing.module';
import { ViewLocalProfileComponent } from './view-local-profile/view-local-profile.component';
import { ViewAdminApprovalComponent } from './locals-log/view-admin-approval/view-admin-approval.component';
import { CreateComponent } from './components/create/create.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
    declarations: [
        LocalsLogComponent,
        ViewLocalProfileComponent,
        ViewAdminApprovalComponent,
        CreateComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        SharedModule,
        LocalsRoutingModule,
        ImageUploadModule.forRoot(),
        NgMultiSelectDropDownModule
    ],
    exports: [
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MainInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true
        },

    ]

})
export class LocalsModule { }
